module.exports = __webpack_public_path__ + "static/infrared_homepage_loop-caaeb6a0652982afb2afc977402f69da.webm";